import React, {useEffect} from 'react'
import UiInputList from "../components/Form/UiInputList";
import UiInputDate from "../components/Form/UiInputDate";
import UiInputSuggest from "../components/Form/UiInputSuggest";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import { useNotification } from '../components/Core/NotificationProvider';

const statusList = [
    { id: 'rascunho', title: 'Rascunho' },
    { id: 'gerado', title: 'Gerado' },
    { id: 'assinado_empresa', title: 'Assinado pela empresa' },
    { id: 'assinado_ambos', title: 'Assinado por ambos' },
    { id: 'vigente', title: 'Vigente' },
    { id: 'encerrado', title: 'Encerrado' },
];

/**
 * Contrato do instalador. O documento não se edita aqui: o texto vem do modelo, e
 * gerar, ver e anexar o assinado são ações do grid.
 *
 * O modelo é a **versão** de modelo, e não o modelo "atual": trocá-lo depois de o
 * contrato estar assinado mudaria o texto de um documento que já foi assinado, e é
 * por isso que a tela avisa em vez de esconder o campo.
 */
export default function ContratoInstaladorForm(props: any){
    const methods = useForm({
        defaultValues: props.data || { status: 'rascunho' }
    });
    const { handleSubmit, reset, watch } = methods;
    const notification = useNotification();

    const versaoAtual = watch('versaoAtual');

    useEffect(() => {
        if (props.data) {
            reset(props.data);
        }
    }, [props.data, reset]);

    const salvar = (dados: any) => {
        if (!dados.instalador?.id) {
            notification.error('O contrato precisa do instalador');
            return;
        }
        if (!dados.modelo?.id) {
            notification.error('O contrato precisa do modelo de contrato');
            return;
        }

        props.triggerSubmit(dados);
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(salvar)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <UiInputSuggest size={12} name="instalador" router="uninstalador" idField="id" titleField="nome" label="Instalador"/>
                        <UiInputSuggest size={12} name="modelo" router="uncontratomodelo" idField="id" titleField="nome" label="Modelo de contrato"/>
                        <UiInputList size={6} name="status" list={statusList} idField="id" titleField="title" label="Status" placeholder={false}/>
                        <UiInputDate size={3} name="vigenciaInicio" label="Vigência de"/>
                        <UiInputDate size={3} name="vigenciaFim" label="Vigência até"/>
                    </div>

                    <fieldset>
                        <legend>Documento</legend>
                        {versaoAtual ? (
                            <div className="row">
                                <div className="col-lg-12">
                                    <p className="text-muted small" style={{ margin: 0 }}>
                                        Versão <b>{versaoAtual.numero}</b>, gerada em {versaoAtual.geradoEm}
                                        {versaoAtual.motivo ? <> &middot; motivo: {versaoAtual.motivo}</> : null}
                                        <br/>
                                        Hash SHA-256 do documento: <code>{versaoAtual.hash}</code>
                                        <br/>
                                        {versaoAtual.totalAssinaturas} assinatura(s) nesta versão
                                        {versaoAtual.temPdf
                                            ? ' · PDF disponível'
                                            : ' · PDF ainda não gerado (o assinador produz o PDF a partir do HTML congelado)'}
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <p className="text-muted small" style={{ margin: 0 }}>
                                Nenhuma versão gerada. Use <b>Gerar versão</b> no grid de contratos.
                            </p>
                        )}
                    </fieldset>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Salvar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
